var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "72px",
    height: "72px",
    viewBox: "0,0,256,256",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.55556,3.55556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,13c-3.314,0 -6,2.686 -6,6v34c0,3.314 2.686,6 6,6h29.33398c-0.199,-0.97 -0.30273,-1.973 -0.30273,-3c0,-1.755 0.31895,-3.434 0.87695,-5h-16.82617l15.36523,-14.19141c1.912,-1.766 4.86034,-1.76881 6.77734,-0.00781l5.11523,4.70117c1.174,-0.296 2.39516,-0.4707 3.66016,-0.4707c2.943,0 5.683,0.86489 8,2.33789v-24.36914c0,-3.314 -2.686,-6 -6,-6zM27,24c2.209,0 4,1.791 4,4c0,2.209 -1.791,4 -4,4c-2.209,0 -4,-1.791 -4,-4c0,-2.209 1.791,-4 4,-4zM25.24805,39.41406c1.16,-0.00212 2.31981,0.39672 3.25781,1.19922l1.51953,1.30078l-9.83789,9.08594h-4.1875c-0.552,0 -1,-0.448 -1,-1v-3.34961l6.99219,-6.02344c0.935,-0.806 2.09586,-1.21077 3.25586,-1.21289zM57,45.03125c-6.058,0 -10.96875,4.91075 -10.96875,10.96875c0,6.058 4.91075,10.96875 10.96875,10.96875c6.058,0 10.96875,-4.91075 10.96875,-10.96875c0,-6.058 -4.91075,-10.96875 -10.96875,-10.96875zM57,49.375c1.104,0 2,0.896 2,2v2.625h2.625c1.104,0 2,0.896 2,2c0,1.104 -0.896,2 -2,2h-2.625v2.625c0,1.104 -0.896,2 -2,2c-1.104,0 -2,-0.896 -2,-2v-2.625h-2.625c-1.104,0 -2,-0.896 -2,-2c0,-1.104 0.896,-2 2,-2h2.625v-2.625c0,-1.104 0.896,-2 2,-2z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload-image.99689cc69005eaa1d49a2b20c5671f0a.svg";